import * as Sentry from "@sentry/browser";

import Segment from "../modules/segment";
import { CheckoutBuild, Product } from "./_build";
import CheckoutValidation from "./_validation";
import CheckoutUtilities from "./_utils";
import AddressAutocomplete from "./_address_autocomplete";
import StripeField from "./_stripe_field";
import PromocodeLookup from "./_promocode_lookup";
import ProductModal from "./_product_modal";
import Utils from "../modules/utils";
import Cookies from "../modules/cookies";

// Globals
window.Segment = Segment;
window.CheckoutBuild = CheckoutBuild;
window.Product = Product;
window.CheckoutValidation = CheckoutValidation;
window.getCookie = Cookies.getCookie;
window.setCookie = Cookies.setCookie;
window.toggleVisible = CheckoutUtilities.toggleVisible;
window.formatCurrency = Utils.formatCurrency;
window.Utils = Utils;
window.AddressAutocomplete = AddressAutocomplete;
window.StripeField = StripeField;
window.PromocodeLookup = PromocodeLookup;
window.ProductModal = ProductModal;
window.Sentry = Sentry;

// Inits
document.addEventListener("DOMContentLoaded", () => {
  // init the Sentry Browser SDK as soon as possible during your page load
  let sentryDSN = $("meta[name=sentry_dsn]").attr("content");
  if (sentryDSN) {
    Sentry.init({
      dsn: sentryDSN,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 1.0,
    });
  }
  Segment.init();
});
